<template>
    <BaseSection width="page-narrow" class="section--accordion">
        <TheAccordion
            :items="children"
            class="the-accordion--big"
        >
            <template #default="{ item }">
                <template v-for="(section, key) in item.children">
                    <component
                        :is="map[section.__typename]"
                        v-if="section.__typename"
                        :key="key"
                        v-bind="section"
                        :sections="sections"
                        class="section--big-accordion"
                    />
                </template>
            </template>
            <template #icon>
                <BaseIcon icon="plus-circle" />
            </template>
        </TheAccordion>
    </BaseSection>
</template>

<script setup>
import { map } from '~/components/FlexibleSections/FlexibleSections.vue';
defineProps({
    children: {
        type: Array,
        default() {
            return [];
        }
    },
    sections: {
        type: Array,
        default() { return []; }
    },
});
</script>
